import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { NeighborhoodFragment } from '@api/fragments'
import { INeighborhood } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteEmployeesFromNeighborhood: {
    neighborhood: INeighborhood
  }
}

const mutation = gql`
  mutation DeleteEmployeesFromNeighborhood($input: DeleteEmployeesFromNeighborhoodInput!) {
    deleteEmployeesFromNeighborhood(input: $input) {
      neighborhood {
        ...NeighborhoodFragment
      }
    }
  }
  ${NeighborhoodFragment}
`

const mutateHandler = handleFetchResult<IPayload, INeighborhood>({
  handler: (data) => data.deleteEmployeesFromNeighborhood.neighborhood,
  name: 'Neighborhood Employees',
})

export default function deleteEmployeesFromNeighborhood(
  neighborhoodId: string,
  employeeIds: string[]
): Promise<INeighborhood> {
  const input = { neighborhoodId, employeeIds }

  return client.gql.mutate<IPayload>({ mutation, variables: { input } }).then(mutateHandler)
}
